<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
                        <a href="#">其他資訊</a>
                    </router-link>
                    <li class="breadcrumb-item">
                        {{ $t("YukiXp") }}
                    </li>
                </ol>
            </nav>
            <div class="item-box">
                <h3 class="item-title">
                    {{ $t("YukiXp") }}
                </h3>
                <div class="form-row align-items-center">
                    <div class="col-md-6 col-12 my-1">
                        <label for="nowLv">{{ $t("current_level") }}</label>
                        <input type="number" class="form-control" id="nowLv" v-model="xpConfig.nowLv" :placeholder="$t('current_level')" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for="targeLv"
                            >{{ $t("target_level") }}<small>{{ $t("target_level_plus_one") }}</small></label
                        >
                        <div class="input-group">
                            <input type="number" class="form-control" id="targeLv" v-model="xpConfig.targeLv" :placeholder="$t('target_level')" />
                        </div>
                    </div>
                </div>
                <h3 class="item-title mt-3">
                    {{ $t("daily_gain_exp") }}
                </h3>
                <div class="form-row align-items-center mb-3">
                    <div class="col-md-6 col-12 my-1">
                        <label for=""
                            >{{ $t("daily_quest") }}<small>{{ $t("take_all_task") }}</small></label
                        >
                        <input type="number" class="form-control" v-model="xpConfig.dailyQuest" placeholder="560" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for="">{{ $t("snack table") }}<small>(48+48+48+48+48+48+48+272)</small></label>
                        <input type="number" class="form-control" v-model="xpConfig.dessert" placeholder="576" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for=""
                            >{{ $t("auto_recovery stamina") }}<small>({{ $t("24hour") }})</small></label
                        >
                        <input type="number" class="form-control" v-model="xpConfig.dailyRecovery" placeholder="240" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for=""
                            >{{ $t("extra_stamina") }}<small>({{ $t("one_time_120") }})</small></label
                        >
                        <input type="number" class="form-control" v-model="xpConfig.plus" placeholder="3" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for=""
                            >{{ $t("other_stamina_source") }}<small>({{ $t("once") }})</small></label
                        >
                        <input type="number" class="form-control" v-model="xpConfig.other" placeholder="0" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for="">{{ $t("level_up_get_stamina") }}</label>
                        <input type="number" class="form-control" placeholder="0" :value="lvUpGiveStamina" disabled="disabled" />
                    </div>
                    <div class="col-md-6 col-12 my-1">
                        <label for="">{{ $t("count_event_extra_exp") }}</label>
                        <select class="form-control" name="" id="" v-model="xpConfig.activeEvent">
                            <option value="0">off</option>
                            <option value="1">on</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="prod-info-box my-3">
                            <div class="row">
                                <div class="col-lg-6 col-12 mb-3">
                                    <div class="prod-data d-flex">
                                        <span class="title">
                                            {{ $t("exp_need") }}
                                        </span>
                                        <span class="prod-value">
                                            {{ lackExp }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-lg-6 col-12 mb-3">
                                    <div class="prod-data d-flex">
                                        <span class="title">
                                            {{ $t("daily_exp_get") }}
                                        </span>
                                        <span class="prod-value">
                                            {{ dayilyGet }}
                                        </span>
                                    </div>
                                </div>
                                <div class="col-12 mb-3">
                                    <div class="prod-data d-flex">
                                        <span class="title">
                                            {{ $t("reach_target_level") }}
                                        </span>
                                        <span class="prod-value"> {{ untillTargetLevel }} {{ $t("day") }} </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import experience_team from "../../assets/edata/experience_team.txt";
import moment from "moment";
export default {
    name: "UnitXp",
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "佑樹計算機",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [{ name: "description", content: "超異域公主連結☆Re:Dive 的主角滿等經驗試算" }],
    },
    data() {
        return {
            exp: {},
            staminaList: {},
            xpConfig: {
                nowLv: "50",
                targeLv: "251",
                plus: "3",
                dessert: "608",
                dailyQuest: "560",
                dailyRecovery: "240",
                lvUpStamina: "0",
                other: "0",
                activeEvent: "1",
            },
        };
    },
    created: function() {
        var self = this;
        var et = JSON.parse(self.atou(experience_team));
        var getNowExp = _.forEach(et, function(o, i) {
            if (i == 0) {
                o["now_exp"] = 0;
                o["totalStamina"] = 0;
                return;
            }
            o["totalStamina"] = Number(o.max_stamina) + Number(et[i - 1]["totalStamina"]);
            var nowExp = Number(o.total_exp) - Number(et[Number(i) - 1]["total_exp"]);
            o["now_exp"] = nowExp;
        });
        self.maxLv = _.last(et);
        self.staminaList = getNowExp;
    },
    computed: {
        totalExp: function() {
            var self = this;
            var rank = self.staminaList[Number(self.xpConfig.nowLv) - 1];
            return rank;
        },
        totalNowExp: function() {
            var self = this;
            var rank = self.staminaList[Number(self.xpConfig.targeLv) - 1];
            return rank;
        },
        lvUpGiveStamina: function() {
            var self = this;
            var lvUp =
                self.staminaList[Number(self.xpConfig.targeLv) - 1].totalStamina - self.staminaList[Number(self.xpConfig.nowLv) - 1].totalStamina;
            self.xpConfig.lvUpStamina = lvUp;
            return lvUp;
        },
        lackExp: function() {
            var other = Number(this.xpConfig.other);
            var lvUp = Number(this.xpConfig.lvUpStamina);
            return Number(this.totalNowExp.total_exp) - Number(this.totalExp.total_exp) - other - lvUp;
        },
        dayilyGet: function() {
            var activeEvent = this.xpConfig.activeEvent;
            let extraXp = 1;
            if (activeEvent == "1") {
                extraXp = 1.25;
            }
            var oneday =
                (Number(this.xpConfig.plus) * 120 +
                    Number(this.xpConfig.dessert) +
                    Number(this.xpConfig.dailyQuest) +
                    Number(this.xpConfig.dailyRecovery)) *
                extraXp;
            return oneday;
        },
        untillTargetLevel: function() {
            var untill = this.lackExp / this.dayilyGet;
            return untill.toFixed(2);
        },
    },
    methods: {
        loadConfig: function() {
            var config = JSON.parse(localStorage.getItem("xpConfig"));
        },
        saveConfig: function() {
            var self = this;
        },
    },
    mounted: function() {
        var self = this;
    },
};
</script>
<style scoped>
small {
    margin-left: 5px;
}
</style>
